import React from "react";
const AboutScript = () => {
    <div>
        <script src="https://embedsocial.com/js/iframe.js"></script>
        <script>iFrameResize();</script>
    </div>
}

export default AboutScript;